import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';

const CustomButton = ({
  title,
  onPressEvent,
  disabled,
  buttonColor,
  textColor,
  customBtnStyles,
  customTextStyles,
  ...rest
}) => {
  return (
    <Button
      disabled={disabled}
      className="p-0 border-0"
      onClick={(e) => onPressEvent?.(e)}
      style={{ background: 'none' }}
      {...rest}
    >
      <div
        style={{
          backgroundColor: buttonColor || 'white',
          color: textColor || '#502D7F',
          padding: '10px 16px',
          borderRadius: '6px',
          textAlign: 'center',
          cursor: disabled ? 'not-allowed' : 'pointer',
          opacity: disabled ? 0.6 : 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          ...(customBtnStyles || {}),
        }}
      >
        <span style={{ fontWeight: "bold", fontSize: 18, textAlign: 'center', ...(customTextStyles || {}) }}>{title}</span>
      </div>
    </Button>
  );
};

CustomButton.propTypes = {
  title: PropTypes.string.isRequired,
  onPressEvent: PropTypes.func,
  disabled: PropTypes.bool,
  buttonColor: PropTypes.string,
  textColor: PropTypes.string,
  customBtnStyles: PropTypes.object,
  customTextStyles: PropTypes.object,
};

export default CustomButton;
